<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit segment</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                Editing of the <span class="secondary--text">{{ this.name }}</span> segment's parameters
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="segment name" v-model="name" name="name"
                                    type="text" readonly>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="max price" v-model.number="priceMax"
                                    name="priceMax" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="min price" v-model.number="priceMin"
                                    name="priceMin" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing habits lowest price"
                                    v-model.number="lowPrice" name="lowPrice" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing habits best quality"
                                    v-model.number="bestQuality" name="bestQuality" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing preferences on-line"
                                    v-model.number="online" name="online" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing preferences off-line"
                                    v-model.number="offline" name="offline" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--values-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="family / kids" v-model.number="family"
                                    name="family" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="attractiveness"
                                    v-model.number="attractiveness" name="attractiveness" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="strong personality"
                                    v-model.number="personality" name="personality" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="social status" v-model.number="soc_status"
                                    name="lowPrice" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="fun" v-model.number="fun" name="fun"
                                    type="text" :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="friendship" v-model.number="friendship"
                                    name="friendship" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="pets" v-model.number="pets" name="pets"
                                    type="text" :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="independent lifestyle"
                                    v-model.number="independent" name="independent" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="High brand importance"
                                    v-model.number="brand_high" name="brand_high" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Somehow brand importance"
                                    v-model.number="brand_somehow" name="brand_somehow" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Not a brand importance"
                                    v-model.number="brand_not" name="brand_not" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--design-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Classic design preferences"
                                    v-model.number="design_classic" name="classic" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Business design preferences"
                                    v-model.number="design_business" name="business" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Casual design preferences"
                                    v-model.number="design_casual" name="casual" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Innovative design preferences"
                                    v-model.number="design_innovative" name="innovative" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Art design preferences"
                                    v-model.number="design_art" name="art" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level1 design preferences"
                                    v-model.number="design_1" name="level1" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level2 design preferences"
                                    v-model.number="design_2" name="level2" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level3 design preferences"
                                    v-model.number="design_3" name="level3" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level4 design preferences"
                                    v-model.number="design_4" name="level4" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level5 design preferences"
                                    v-model.number="design_5" name="level5" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--material-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level1 material preferences"
                                    v-model.number="material_1" name="material1" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level2 material preferences"
                                    v-model.number="material_2" name="material2" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level3 material preferences"
                                    v-model.number="material_3" name="material3" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level4 material preferences"
                                    v-model.number="material_4" name="material4" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level5 material preferences"
                                    v-model.number="material_5" name="material5" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--manufacturing-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level1 manufacturing preferences"
                                    v-model.number="manufacturing_1" name="manufacturing1" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level2 manufacturing preferences"
                                    v-model.number="manufacturing_2" name="manufacturing2" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level3 manufacturing preferences"
                                    v-model.number="manufacturing_3" name="manufacturing3" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level4 manufacturingn preferences"
                                    v-model.number="manufacturing_4" name="manufacturing4" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level5 manufacturing preferences"
                                    v-model.number="manufacturing_5" name="manufacturing5" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!haveBeenChanged || Boolean(error)"
                    @click="editSegment">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'EditMarketSegment',
    props: ['segment'],
    data() {
        return {
            dialog: false,
            valid: false,
            haveBeenChanged: false,
            error: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            name: this.segment.segment?.name,
            priceMax: this.segment.max_price,
            priceMin: this.segment.min_price,
            lowPrice: this.segment.lowest_price,
            bestQuality: this.segment.best_quality,
            online: this.segment.on_line,
            offline: this.segment.off_line,
            family: this.segment.family,
            attractiveness: this.segment.attractiveness,
            personality: this.segment.personality,
            soc_status: this.segment.social_status,
            fun: this.segment.fun,
            friendship: this.segment.friendship,
            pets: this.segment.pets,
            independent: this.segment.independent,
            brand_high: this.segment.brand_high,
            brand_somehow: this.segment.brand_somehow,
            brand_not: this.segment.brand_not,
            design_classic: this.segment.design_classic,
            design_business: this.segment.design_business,
            design_casual: this.segment.design_casual,
            design_innovative: this.segment.design_innovative,
            design_art: this.segment.design_art,
            design_1: this.segment.design_1,
            design_2: this.segment.design_2,
            design_3: this.segment.design_3,
            design_4: this.segment.design_4,
            design_5: this.segment.design_5,
            material_1: this.segment.material_1,
            material_2: this.segment.material_2,
            material_3: this.segment.material_3,
            material_4: this.segment.material_4,
            material_5: this.segment.material_5,
            manufacturing_1: this.segment.manufacturing_1,
            manufacturing_2: this.segment.manufacturing_2,
            manufacturing_3: this.segment.manufacturing_3,
            manufacturing_4: this.segment.manufacturing_4,
            manufacturing_5: this.segment.manufacturing_5,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        }
    },
    methods: {

        onceMore() {
            this.error = '';
            this.haveBeenChanged = true;
        },
        async editSegment() {

            if (this.$refs.form.validate() && this.haveBeenChanged) {
            
                const segment = {
                    id: this.segment.id,
                    gameId: this.segment.gameId,
                    round: this.segment.round,
                    segmentId: this.segment.segmentId,
                    segment: this.segment.segment,
                    max_price: this.priceMax,
                    min_price: this.priceMin,
                    lowest_price: this.lowPrice,
                    best_quality: this.bestQuality,
                    on_line: this.online,
                    off_line: this.offline,
                    family: this.family,
                    attractiveness: this.attractiveness,
                    personality: this.personality,
                    social_status: this.soc_status,
                    fun: this.fun,
                    friendship: this.friendship,
                    pets: this.pets,
                    independent: this.independent,
                    brand_high: this.brand_high,
                    brand_somehow: this.brand_somehow,
                    brand_not: this.brand_not,
                    design_classic: this.design_classic,
                    design_business: this.design_business,
                    design_casual: this.design_casual,
                    design_innovative: this.design_innovative,
                    design_art: this.design_art,
                    design_1: this.design_1,
                    design_2: this.design_2,
                    design_3: this.design_3,
                    design_4: this.design_4,
                    design_5: this.design_5,
                    material_1: this.material_1,
                    material_2: this.material_2,
                    material_3: this.material_3,
                    material_4: this.material_4,
                    material_5: this.material_5,
                    manufacturing_1: this.manufacturing_1,
                    manufacturing_2: this.manufacturing_2,
                    manufacturing_3: this.manufacturing_3,
                    manufacturing_4: this.manufacturing_4,
                    manufacturing_5: this.manufacturing_5
                }

                try {
                    //edit market-segment 
                    await this.$store.dispatch('editMarketSegment', segment)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false
            this.error = ''
            this.haveBeenChanged = false;

            this.name = this.segment.segment.name
            
            this.priceMax = this.segment.max_price
            this.priceMin = this.segment.min_price
            this.lowPrice = this.segment.lowest_price
            this.bestQuality = this.segment.best_quality
            this.online = this.segment.on_line
            this.offline = this.segment.off_line
            this.family = this.segment.family
            this.attractiveness = this.segment.attractiveness
            this.personality = this.segment.personality
            this.soc_status = this.segment.social_status
            this.fun = this.segment.fun
            this.friendship = this.segment.friendship
            this.independent = this.segment.independent
            this.pets = this.segment.pets
            this.brand_high = this.segment.brand_high
            this.brand_somehow = this.segment.brand_somehow
            this.brand_not = this.segment.brand_not
            this.design_classic = this.segment.design_classic
            this.design_business = this.segment.design_business
            this.design_casual = this.segment.design_casual
            this.design_innovative = this.segment.design_innovative
            this.design_art = this.segment.design_art
            this.design_1 = this.segment.design_1
            this.design_2 = this.segment.design_2
            this.design_3 = this.segment.design_3
            this.design_4 = this.segment.design_4
            this.design_5 = this.segment.design_5
            this.material_1 = this.segment.material_1
            this.material_2 = this.segment.material_2
            this.material_3 = this.segment.material_3
            this.material_4 = this.segment.material_4
            this.material_5 = this.segment.material_5
            this.manufacturing_1 = this.segment.manufacturing_1
            this.manufacturing_2 = this.segment.manufacturing_2
            this.manufacturing_3 = this.segment.manufacturing_3
            this.manufacturing_4 = this.segment.manufacturing_4
            this.manufacturing_5 = this.segment.manufacturing_5
        }
    }
}
</script>